import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { fmtDateTime } from "@/lib/roles";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AuditLogs() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/audit-logs?limit=100").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Compliance</div>
        <h1 className="text-2xl sm:text-3xl font-heading font-semibold flex items-center gap-2"><ShieldCheck className="w-6 h-6" /> Audit Log</h1>
        <p className="text-sm text-slate-500 mt-1">Every mutation, login and payment is logged.</p>
      </div>
      <Card>
        <CardContent className="p-0">
          {loading ? <div className="p-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div> : (
            <div className="divide-y">
              {items.map((a) => (
                <div key={a.id} className="p-4 flex items-start gap-4">
                  <div className="w-10 h-10 rounded bg-[#0F2942]/10 flex items-center justify-center flex-shrink-0">
                    <ShieldCheck className="w-4 h-4 text-[#0F2942]" />
                  </div>
                  <div className="flex-1">
                    <div className="text-sm font-medium">
                      <Badge variant="outline" className="mr-2">{a.action}</Badge>
                      {a.user_email || "system"}
                    </div>
                    <div className="text-xs text-slate-500 mt-1">
                      {a.entity && `${a.entity} · ${a.entity_id || ""}`}
                      {a.ip && ` · IP ${a.ip}`}
                    </div>
                    {a.details && Object.keys(a.details).length > 0 && (
                      <div className="text-xs text-slate-600 dark:text-slate-400 mt-1 font-mono">{JSON.stringify(a.details)}</div>
                    )}
                  </div>
                  <div className="text-xs text-slate-500 flex-shrink-0">{fmtDateTime(a.created_at)}</div>
                </div>
              ))}
              {items.length === 0 && <div className="p-10 text-center text-slate-500">No audit entries yet.</div>}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
